import { Button } from "antd";
import { useCallback, useEffect, useState } from "react";
import { isEmpty } from "lodash";
import usePageState from "../../hooks/usePageState";
import { useAuth } from "../../context/AuthContext";
import {
  LOCAL_STORAGE_KEY_AUTH,
  PRIVILEGE_ROLE_ENUM,
} from "../../../applications/constants/AppConst";
import Scaffold from "../../components/Scaffold";
import Column from "../../components/Column";
import AppInputText from "../../components/AppInputText/AppInputText";
import { UserOutlined } from "@ant-design/icons";
import "./Login.scss";
import { Link, useNavigate } from "react-router-dom";
import JwtUtils from "../../../applications/utils/JwtUtils";
import RegisterForm from "./Register";
import { loginUseCase } from "../../../applications/useCase/ApiUseCase/AuthenticationApiUseCase";

function LoginPage() {
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const [openRegisterForm, setOpenRegisterForm] = useState<boolean>(false);

  const navigate = useNavigate();
  const { setAuthData } = useAuth();

  const { isLoading, setLoading, showClientError, showError, showSuccess } = usePageState();

  async function handleLogin() {
    if (isEmpty(username) || isEmpty(password)) {
      showClientError("Vui lòng nhập đầy đủ thông tin đăng nhập");
      return;
    }
    if (password?.length < 8) {
      showClientError("Mật khẩu phải có độ dài lớn hơn 8 kí tự");
      return;
    }

    const res = await loginUseCase({
      userName: username,
      password: password,
      setLoading,
      showError,
      showSuccess,
    });

    if (res) {
      localStorage.setItem(LOCAL_STORAGE_KEY_AUTH, JSON.stringify(res));
      const parseToken = JwtUtils.decode(res.access_token) as any;
      const privilege = parseToken?.privileges;
      setAuthData({
        ...res,
        use_admin_site: [PRIVILEGE_ROLE_ENUM.ADMINISTRATOR, PRIVILEGE_ROLE_ENUM.EMPLOYEE]?.includes(
          privilege
        ),
        role: privilege,
      });
      if ([PRIVILEGE_ROLE_ENUM.ADMINISTRATOR, PRIVILEGE_ROLE_ENUM.EMPLOYEE]?.includes(privilege)) {
        navigate("/admin", { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    }
  }

  const keyDownHandler = useCallback(
    async (event: KeyboardEvent) => {
      if (event.key !== "Enter") return;
      event.preventDefault();
      handleLogin();
    },
    [username, password]
  );

  useEffect(() => {
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [keyDownHandler]);

  return (
    <Scaffold isLoading={isLoading}>
      <div className="flex align-items-center justify-content-center w-100 h-100" id="sign-in-btn">
        <div
          style={{
            width: 400,
            background: "white",
          }}
          className="p-4 shadow-2 border-round"
        >
          <div className="login-title-wrapper">
            <h1 className="login-title">TOPUTII</h1>
            <p className="login-subtitle">Trà sữa yêu thích chỉ cách bạn vài cú nhấp chuột 💖</p>
          </div>
          {openRegisterForm ? (
            <RegisterForm setOpenRegisterForm={setOpenRegisterForm} />
          ) : (
            <Column className={`gap-2`}>
              <label htmlFor="username" className="block mb-1" style={{ fontSize: "14px" }}>
                Tài khoản
              </label>
              <AppInputText
                currentValue={username}
                onTextChange={(value) => {
                  setUsername(value);
                }}
                additionProps={{
                  className: "w-100",
                  autoFocus: true,
                  autoComplete: "username",
                }}
              />

              <label htmlFor="password" className="block mt-1" style={{ fontSize: "14px" }}>
                Mật khẩu
              </label>
              <AppInputText
                currentValue={password}
                onTextChange={(value) => {
                  setPassword(value);
                }}
                additionProps={{
                  className: "w-100",
                  onCut: (e: React.ClipboardEvent<HTMLInputElement>) => {
                    e.preventDefault();
                  },
                  onCopy: (e: React.ClipboardEvent<HTMLInputElement>) => {
                    e.preventDefault();
                  },
                }}
                textType={"PASSWORD"}
              />
              <Link to={""} style={{ fontSize: "13px" }} onClick={() => setOpenRegisterForm(false)}>
                Quên mật khẩu?
              </Link>
              <Button
                onClick={handleLogin}
                icon={<UserOutlined />}
                type="primary"
                style={{
                  height: 36,
                  marginTop: "1.5rem",
                }}
              >
                Đăng nhập
              </Button>
            </Column>
          )}
          <div className="flex mt-3 mb-2 justify-content-center">
            {openRegisterForm ? (
              <div style={{ fontSize: "13px" }}>
                Bạn đã có tài khoản?{" "}
                <button
                  type="button"
                  className="link-like"
                  onClick={() => setOpenRegisterForm(false)}
                >
                  Đăng nhập tại đây
                </button>
              </div>
            ) : (
              <div style={{ fontSize: "13px" }}>
                Bạn chưa có tài khoản?{" "}
                <button
                  type="button"
                  className="link-like"
                  onClick={() => setOpenRegisterForm(true)}
                >
                  Đăng ký tại đây
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Scaffold>
  );
}
export default LoginPage;
